import React from "react";

/* ─────────────────────────────────────────────
   Section Header Component
───────────────────────────────────────────── */
export const Section = ({
  icon,
  title,
  subtitle,
  action,
  className = "",
}) => {
  return (
    <div
      className={`d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom ${className}`}
    >
      <div className="d-flex align-items-center gap-2">
        <div
          className="d-flex align-items-center justify-content-center rounded-2 text-white"
          style={{
            width: 34,
            height: 34,
            background: "linear-gradient(135deg,#4f6ef7,#6c5ce7)",
            fontSize: 16,
            flexShrink: 0,
          }}
        >
          {icon}
        </div>

        <div>
          <div
            className="fw-bold"
            style={{
              fontSize: 14,
              color: "#1a1d2e",
              lineHeight: 1.2,
            }}
          >
            {title}
          </div>

          {subtitle && (
            <div style={{ fontSize: 12, color: "#8a90a2" }}>
              {subtitle}
            </div>
          )}
        </div>
      </div>

      {action && <div>{action}</div>}
    </div>
  );
};

/* ─────────────────────────────────────────────
   Day Chip Component
───────────────────────────────────────────── */
export const DayChip = ({ day, className = "" }) => {
  if (!day) return null;

  return (
    <span
      className={`badge rounded-pill px-3 py-2 ms-2 ${className}`}
      style={{
        fontSize: 11,
        background: "#e8f0fe",
        color: "#4f6ef7",
        border: "1px solid #c7d1fc",
        fontWeight: 700,
      }}
    >
      Day {day}
    </span>
  );
};

/* ─────────────────────────────────────────────
   Info Strip Component
───────────────────────────────────────────── */
export const InfoStrip = ({ items = [], className = "" }) => {
  const filteredItems = items.filter(
    (item) => item && (item.label || item.value)
  );

  if (!filteredItems.length) return null;

  return (
    <div
      className={`d-flex flex-wrap gap-3 p-3 rounded-3 mb-4 ${className}`}
      style={{
        background: "#f8f9fc",
        border: "1.5px solid #e2e5ef",
      }}
    >
      {filteredItems.map(({ label, value, color }, index) => (
        <div
          key={index}
          className="d-flex align-items-center gap-2"
          style={{ fontSize: 13 }}
        >
          <span className="text-secondary fw-semibold">
            {label}:
          </span>

          <span
            className="fw-bold"
            style={{ color: color || "#1a1d2e" }}
          >
            {value || "—"}
          </span>
        </div>
      ))}
    </div>
  );
};